var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.taskInfo.popCoinAnim.show ? _c('div', [_c('div', {
    ref: "destoryCoinContainerRef",
    staticClass: "getCoinAnim-container"
  })]) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };